import FindAgentBlock from '../components/FindAgentBlock';

import React, { useRef } from 'react'
import ProgressiveImg from '../components/ProgressiveImg';
import HtmlText from '../components/HtmlText';

import useScrollSpy from 'react-use-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import '../assets/styles/pages/_about-our-companies.scss'

export const AboutOurCompanies = () => {
  const sectionRefs = [useRef(null), useRef(null), useRef(null)];

  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: 0
  });

  const sideMenuItems = [
    { id: 0, text: 'RVOS Farm Mutual Insurance Company', url: '#anchor1' },
    { id: 1, text: 'Priority One Insurance Company', url: '#anchor2' },
    { id: 2, text: 'RVOS General Agency', url: '#anchor3' }
  ]

  const cards = [
    {
      id: 0,
      anchor: 'anchor1',
      mainTitle: 'RVOS Farm Mutual Insurance Company',
      date: 1901,
      dateText: 'Organized',
      titleAbout: 'About',
      textAbout: `
        RVOS Farm Mutual Insurance Company operates under Chapter 911 of the Texas Insurance Code as a farm mutual insurance company.</br></br>
        <img src="${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/company.jpg">
        <span class="image-subtitle">Board of Directors</span>
        <div class="block-cite">
        <cite><strong>Pictured front row (L-R): </strong>Secretary Renee Quinn, Vice President Wes Jackson, President Wiley Shockley, Vice President-At-Large Richard Hykel</cite>
        <cite><strong>Back row (L-R): </strong>District 7 Director Wayne Wilson, District 5 Director Ryan Thoma, District 2 Director Claude Hempel, District 4 Director Dennis Vanek, District 1 Director Joe Liles, District 6 Director Jason Tully, District 3 Director Tom Stavinoha</cite>
        </div>
        Our focus is to provide insurance products to homeowners, farmers, and ranchers in Texas. Being a farm mutual insurance company gives us a unique ability to adapt quickly to new circumstances, allowing us to offer a variety of insurance products that can meet various needs and budgets.</br>
        RVOS Insurance is owned by our policyholders. This allows us to focus on providing the best products and services to meet the ever-changing needs of our members rather than turning a profit for an out-of-state parent corporation. Our profits, on the other hand, are held in surplus to pay future claims and offset future premium increases.
      `,
      typesTitle: 'Types of coverage',
      typesArray: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/farm.png`, text: 'Farm and Ranch' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/house.png`, text: 'Dwelling and Personal Property' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/manufacturedhouse.png`, text: 'Manufactured and Mobile Home' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/church.png`, text: 'Organization' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/duplex.png`, text: 'Landlord' }
  ]
    },
    {
      id: 1,
      anchor: 'anchor2',
      mainTitle: 'Priority One Insurance Company',
      date: 1979,
      dateText: 'Organized',
      titleAbout: 'About',
      textAbout: `
      Priority One Insurance Company is a licensed property and casualty insurance company and 
      a wholly owned subsidiary of the RVOS Farm Mutual Insurance Company.
      `,
      typesTitle: 'Types of coverage',
      typesArray: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/farm.png`, text: 'Farm Liability' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/persona.png`, text: 'Personal Liability' }
      ]
    },
    {
      id: 2,
      anchor: 'anchor3',
      mainTitle: 'RVOS General Agency',
      date: 1999,
      dateText: 'Organized',
      titleAbout: 'About',
      textAbout: `
        The RVOS General Agency is a wholly owned subsidiary of Priority One Insurance Company. 
      `,
      typesTitle: 'Types of coverage',
      typesArray: [
        { id: 0, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/auto.png`, text: 'Personal and Commercial Auto' },
        { id: 1, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/motorcycle.png`, text: 'Motorcycle' },
        { id: 2, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/vehicles.png`, text: 'Recreational Vehicles' },
        { id: 3, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/boat.png`, text: 'Boat' },
        { id: 4, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/motorhomes2.png`, text: 'Motor Homes' },
        { id: 5, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/house.png`, text: 'Dwelling and Personal Property' },
        { id: 6, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/traveltrailers.png`, text: 'Travel Trailers' },
        { id: 7, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/manufacturedhouse.png`, text: 'Mobile Homes' },
        { id: 8, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/flood.png`, text: 'Flood' },
        { id: 9, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/umbrella.png`, text: 'Personal Umbrella' },
        { id: 10, img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/persona.png`, text: 'Life' }
      ]
    }
  ];

  return (
    <>
      <div className="about-companies-page">

        <div className="about-block-1">
          <ProgressiveImg
            lowQualitySrc={ `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/first-block-right.png`}
            highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/first-block-right.svg`}
            className="right-picture"
          />
          <ProgressiveImg
            lowQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/first-block-left.png`}
            highQualitySrc={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/first-block-left.svg`}
            className="left-picture"
          />
          <img className="mobile-picture" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/mobile-picture.png`} alt="Our Companies mobile view"/>
          <img className="xs-picture" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/our-companies/xs-picture.png`} alt="Our Companies extra small view"/>
          <div className="title">
            Our Companies
          </div>
          <div className="undertitle">
            Our mission is to provide quality insurance to our customers, continue  to improve our current products, develop new products and provide sound management and customer service at an exceptional level.
          </div>
        </div>

        <div className="container">
          <div className="main-block">
            <aside>
              <ul>
                {
                  sideMenuItems.map((item, index) => {
                    return <li key={item.id}>
                      <AnchorLink
                        className={activeSection === index ? 'active' : ''}
                        href={item.url}
                        offset={-20}
                      >
                        {item.text}
                      </AnchorLink>
                    </li>
                  })
                }
              </ul>
            </aside>
            <main>
              {
                cards.map((item, index) => {
                  return (
                      <div className="main-card" key={item.id} >
                        <div className="main-card__ref" id={item.anchor} ref={sectionRefs[index]}/>
                        <div className="title-line">
                          <div className="title-main">{item.mainTitle}</div>
                          <div className="data-block">
                            <div className="data">{item.date}</div>
                            <div className="text">{item.dateText}</div>
                          </div>
                        </div>
                        <div className="title-about">{item.titleAbout}</div>
                        <HtmlText className="text-about">{item.textAbout}</HtmlText>
                        <div className="types-coverage-title">{item.typesTitle}</div>
                        <div className="types-items">
                          {
                            item.typesArray.map(item => {
                              return <div className="type-item" key={item.id}>
                                <div className="picture">
                                  <img src={item.img} alt="" />
                                </div>
                                <div className="text">{item.text}</div>
                              </div>
                            })
                          }

                        </div>
                      </div>
                  )
                })
              }
            </main>
          </div>
        </div>

        <FindAgentBlock />
      </div>
    </>
  );
}
